// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_benefit5_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Active walking pumps blood more effectively through your legs.`
};

const el_tech_benefit5_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Το ενεργό περπάτημα αντλεί αίμα πιο αποτελεσματικά μέσα από τα πόδια σας.`
};

const ru_tech_benefit5_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Активная ходьба эффективнее прокачивает кровь по ногам.`
};

const he_tech_benefit5_detail = /** @type {(inputs: {}) => string} */ () => {
	return `הליכה פעילה משפרת את זרימת הדם ברגליים.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_benefit5_detail = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_benefit5_detail(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_benefit5_detail", locale)
	if (locale === "en") return en_tech_benefit5_detail(inputs)
	if (locale === "el") return el_tech_benefit5_detail(inputs)
	if (locale === "ru") return ru_tech_benefit5_detail(inputs)
	if (locale === "he") return he_tech_benefit5_detail(inputs)
	return "tech_benefit5_detail"
};